import React from 'react';
import { Link } from 'react-router-dom';
import '../../Styles/Footer.css';
import YMCBigLogoTransparent from '../../Photos/YMCBigLogoTransparent.svg';

export default function B2BFooter() {
  return (
    <footer className="PageFooter py-8 md:py-10">
      <div className="PageFooterContent border-b border-white/40 pb-6">
        <div className="PageFooterFlexedLinks my-0">
          <div className="PageFooterLeftLogoDiv">
            <img alt="Yo Me Controlo" className="PageFooterLeftLogo" src={YMCBigLogoTransparent} />
            <p className="text-[13px] text-white/80 leading-[1.5] mt-3">
              BAC, de Yo Me Controlo
            </p>
            <p className="text-[12px] text-white/70 leading-[1.5]">
              Yo Me Controlo desarrolla BAC para APS.
            </p>
          </div>

          <div className="PageFooterLinkColumnsFlex">
            <div className="PageFooterLinkColumn">
              <div className="PageFooterLinkColumnTitle text-[12px] uppercase tracking-widest mb-2">Navegación</div>
              <nav>
                <div className="PageFooterLinkColumnSingleLink"><Link to="/">Inicio</Link></div>
                <div className="PageFooterLinkColumnSingleLink"><Link to="/bac">BAC</Link></div>
                <div className="PageFooterLinkColumnSingleLink"><Link to="/resultados">Resultados</Link></div>
                <div className="PageFooterLinkColumnSingleLink"><Link to="/implementacion">Implementación</Link></div>
              </nav>
            </div>

            <div className="PageFooterLinkColumn">
              <div className="PageFooterLinkColumnTitle text-[12px] uppercase tracking-widest mb-2">Legal</div>
              <nav>
                <div className="PageFooterLinkColumnSingleLink"><Link to="/privacidad">Privacidad</Link></div>
                <div className="PageFooterLinkColumnSingleLink"><Link to="/terminos">Términos</Link></div>
              </nav>
            </div>

            <div className="PageFooterLinkColumn">
              <div className="PageFooterLinkColumnTitle text-[12px] uppercase tracking-widest mb-2">Contacto</div>
              <div className="PageFooterLinkColumnSingleLink">
                <a href="mailto:contacto@yomecontrolo.cl">contacto@yomecontrolo.cl</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1140px] mx-auto pt-4 flex flex-col md:flex-row justify-between gap-4 text-[11px] text-white/70">
        <p>© 2026 Yo Me Controlo. Todos los derechos reservados.</p>
        <div className="flex gap-4 uppercase tracking-widest">
          <span>Start-Up Chile</span><span>CORFO</span><span>ANID</span>
        </div>
      </div>
    </footer>
  );
}
